export const mimeTypes = [
  'video/webm;codecs=vp9,opus',
  'video/webm;codecs=vp8,opus',
  'video/webm;codecs=avc1',
  'video/webm',
  'video/mp4;codec=avc1',
  'video/mp4;codec=mp4a',
  'video/mp4',
];

export const DEFAULT_MIME_TYPE = 'video/mp4';
